import { defineComponent, onErrorCaptured } from 'vue';
import { sentryErrorHandler } from '../sentry';
/**
 * This is a transparent component that captures errors propagating from
 * descendant components and captures it with sentry with extra information
 * about the microfrontend to ensure it's routed to the correct sentry project.
 *
 * It renders the default slot with props passed through transparently.
 */
export default defineComponent({
    name: 'ErrorBoundary',
    slots: Object,
    setup(props, { slots, attrs }) {
        onErrorCaptured((err, vm, info) => {
            sentryErrorHandler(err, vm, info, __APP_NAME__);
            return false;
        });
        return () => slots.default(props);
    },
});
//# sourceMappingURL=ErrorBoundary.js.map